import { useEffect, useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { logTokenAtom, getToken } from '../atoms/log/LogTokenStore';
import { createLog } from '../atoms/log/LogFunction';

const LOG_EVENTS = {
    VISIT: 'visit',
    VIEW_PAGE: 'view_page',
};

export const useLogging = (currentPath) => {
    const [logTokenState, setLogTokenState] = useRecoilState(logTokenAtom);

    const logPageVisit = useCallback(async () => {
        try {
            const token = await getToken();

            const visitLogOption = {
                page: currentPath,
                eventName: LOG_EVENTS.VISIT,
                eventValue: null,
                sessionToken: token,
                properties: {
                    referrer: document.referrer,
                },
            };

            const newToken = await createLog(visitLogOption);

            if (newToken) {
                const viewLogOption = {
                    page: currentPath,
                    eventName: LOG_EVENTS.VIEW_PAGE,
                    eventValue: null,
                    sessionToken: newToken,
                };

                const finalToken = await createLog(viewLogOption);
                setLogTokenState(finalToken);
            }
        } catch (error) {
            console.error('로깅 중 오류 발생:', error);
            // 에러 발생 시에도 앱은 정상 동작하도록 함
        }
    }, [currentPath, setLogTokenState]);

    useEffect(() => {
        if (logTokenState === null) {
            logPageVisit();
        }
    }, [logTokenState, logPageVisit]);

    return { logTokenState };
};
